exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-border[data-v-a1d53878] {\n  border-left: #ffc107 solid 2px;\n}\n", ""]);

// exports
